import React from "react";

export default function IndustryExpertise() {
  const columns = [
    [
      "Consumer Products",
      "Consumer Electronics",
      "SaaS",
      "Staffing & Recruiting",
      "Human Resources",
    ],
    ["Insurance Tech", "Lifestyle Brands", "Ecommerce", "Insurance", "FinTech"],
    [
      "Financial Services & Banks",
      "Logistics & Supply Chain",
      "Management Consulting",
      "Health, Wellness & Fitness",
      "Marketing Agencies",
    ],
    [
      "Fashion & Apparel",
      "Food & Beverages",
      "Higher Education",
      "Medical Devices",
      "IT & Services",
    ],
  ];

  const segments = [
    {
      title: "SME & Startups",
      desc: "Focused on creative storytelling, cost-effective content, and high-impact visuals to drive growth",
    },
    {
      title: "Mid-market",
      desc: "Focused on professional, scalable video content to elevate brand presence, engage customers, and accelerate growth",
    },
    {
      title: "Enterprise",
      desc: "Focused on high-quality, strategic video content to strengthen brand leadership, inspire audiences, and drive global impact",
    },
  ];

  return (
    <section className="w-full bg-[#F6F6F6]">
      <div className="mx-auto max-w-[1400px] container px-6 py-14">
        {/* Heading */}
        <h2 className="text-center tracking-tight text-neutral-900 font-semibold text-[1.2rem] md:text-[2.2rem] mb-2">
          What’s Your Industry Expertise?
        </h2>

        {/* Row 1 — Four lists */}
        <div className="mt-8 grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-x-5 sm:gap-x-10 justify-center place-content-center justify-items-left gap-y-6 ml-4 sm:ml-0">
          {columns.map((list, i) => (
            <ul
              key={i}
              className="space-y-0 lg:space-y-2 text-[10px] sm:text-xs lg:text-[15px] leading-5 sm:leading-6 text-neutral-900 text-left"
            >
              {list.map((item, j) => (
                <li
                  key={j}
                  className="relative pl-4 sm:pl-5 before:content-['•'] before:absolute before:left-0 before:top-0.5 before:text-[14px] sm:before:text-[18px] before:leading-none before:text-neutral-900"
                >
                  {item}
                </li>
              ))}
            </ul>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-10 text-center md:divide-x divide-gray-300">
          {segments.map((s, i) => (
            <div key={i} className="px-8 py-6">
              <h3 className="text-[24px] md:text-[26px] font-extrabold tracking-tight text-neutral-900">
                {s.title}
              </h3>
              <p className="mt-2 text-[14px] leading-relaxed text-neutral-600 max-w-[360px] mx-auto">
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
